// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntitlementType } from './EntitlementType';
import {
  EntitlementTypeFromJSON,
  EntitlementTypeFromJSONTyped,
  EntitlementTypeToJSON,
  EntitlementTypeToJSONTyped,
} from './EntitlementType';

/**
 *
 * @export
 * @interface UpdateEntitlementRequest
 */
export interface UpdateEntitlementRequest {
  /**
   * start timestamp, RFC3339
   * @type {Date}
   * @memberof UpdateEntitlementRequest
   */
  start: Date;
  /**
   * end timestamp, RFC3339
   * @type {Date}
   * @memberof UpdateEntitlementRequest
   */
  end: Date;
  /**
   * cost basis
   * @type {string}
   * @memberof UpdateEntitlementRequest
   */
  costBasis: string;
  /**
   * amount of ACUs
   * @type {number}
   * @memberof UpdateEntitlementRequest
   */
  amount: number;
  /**
   * percentage of unused ACUs that roll over to the next period (optional)
   * @type {number}
   * @memberof UpdateEntitlementRequest
   */
  rolloverPercentage?: number;
  /**
   *
   * @type {EntitlementType}
   * @memberof UpdateEntitlementRequest
   */
  type: EntitlementType;
  /**
   * Salesforce subscription ID (optional)
   * @type {string}
   * @memberof UpdateEntitlementRequest
   */
  salesforceSubID?: string;
  /**
   * provisioning ID (optional)
   * @type {string}
   * @memberof UpdateEntitlementRequest
   */
  provisioningID?: string;
}

/**
 * Check if a given object implements the UpdateEntitlementRequest interface.
 */
export function instanceOfUpdateEntitlementRequest(
  value: object,
): value is UpdateEntitlementRequest {
  if (!('start' in value) || value['start'] === undefined) return false;
  if (!('end' in value) || value['end'] === undefined) return false;
  if (!('costBasis' in value) || value['costBasis'] === undefined) return false;
  if (!('amount' in value) || value['amount'] === undefined) return false;
  if (!('type' in value) || value['type'] === undefined) return false;
  return true;
}

export function UpdateEntitlementRequestFromJSON(
  json: any,
): UpdateEntitlementRequest {
  return UpdateEntitlementRequestFromJSONTyped(json, false);
}

export function UpdateEntitlementRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateEntitlementRequest {
  if (json == null) {
    return json;
  }
  return {
    start: new Date(json['start']),
    end: new Date(json['end']),
    costBasis: json['costBasis'],
    amount: json['amount'],
    rolloverPercentage:
      json['rolloverPercentage'] == null
        ? undefined
        : json['rolloverPercentage'],
    type: EntitlementTypeFromJSON(json['type']),
    salesforceSubID:
      json['salesforceSubID'] == null ? undefined : json['salesforceSubID'],
    provisioningID:
      json['provisioningID'] == null ? undefined : json['provisioningID'],
  };
}

export function UpdateEntitlementRequestToJSON(
  json: any,
): UpdateEntitlementRequest {
  return UpdateEntitlementRequestToJSONTyped(json, false);
}

export function UpdateEntitlementRequestToJSONTyped(
  value?: UpdateEntitlementRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    start: value['start'].toISOString(),
    end: value['end'].toISOString(),
    costBasis: value['costBasis'],
    amount: value['amount'],
    rolloverPercentage: value['rolloverPercentage'],
    type: EntitlementTypeToJSON(value['type']),
    salesforceSubID: value['salesforceSubID'],
    provisioningID: value['provisioningID'],
  };
}
